import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { auth, firestore as db } from '../config/Config';

const initialState = {
  userData: [],
  userLoader: true,
  userError: '',
};

export const fetchUserList = createAsyncThunk('user/fetchUserList', async ({ userUID }) => {
  const projectList = await fetch(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/users/${userUID}`);
  const projectListArray = await projectList.JSON.stringify();
  console.log("user redux data", projectListArray);
  return projectListArray;
});

const userReducer = createSlice({
  name: 'viewusers',
  initialState,
  reducers: {},
  extraReducers:{
    [fetchUserList.fulfilled]:(state,action)=>{
        state.userData = action.payload
        state.userLoader = false
    },
    [fetchUserList.pending]:(state,action)=>{
        state.userLoader = true
    },
    [fetchUserList.rejected]:(state,action)=>{
        state.userError = "refresh the page"
    },
}
});

export default userReducer.reducer;
